import React from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import { TransitionGroup } from 'react-transition-group';
import { connect } from 'react-redux';

import Overlay from '../Widget/Overlay';
import OverlayPartner from '../Widget/OverlayPartner';
import OverlayPublisher from '../Widget/OverlayPublisher';
import WidgetHeader from '../Widget/WidgetHeader';

import { Body, Content, Container, ContentContainer } from '../DefaultStyles/Details';
import CssTransition from '../../components/Transition/CssTransition';
import DetailsFormMultiRepStep2 from '../../components/Email/DetailsFormMultiRepStep2';
import RepEmailRedirectPopup from '../../components/LocalRep/RepEmailRedirectPopup';
import ToasterAlert from '../../components/Donation/ToasterAlert';
import TransitionContainer from '../../components/Transition/TranstionContainer';

import {
    onGoToNextCard,
    setExitingCardProps,
    getExitingCardProps,
    widgetBounce
} from '../Widget/actions';
import {
    onEmailComplete,
    onEmailMessageChange,
    onBackFromStep2,
    setPrefixModalVisibility
} from './actions';

import {
    toggleDoubleCheckRepPopup,
    hideFindRepPopup,
    loadLocalRep
} from '../LocalRep/actions';

import {
    buildConditionalActionsAnswerHistory,
    getNextAction
} from '../../utils/nextActionUtil';
import {
    relevantRepresentatives,
    joinEnglish,
    districtInfo
} from '../../utils/localRepresentative/parser';
import { cacheFormData } from '../../utils/formCaching/actions';
import { CardTypes } from '../../utils/enums';
import { getActionCompletedTime } from '../../utils/actionTiming';
import { handleSkippingEndCard } from '../../utils/handleSkippingEndCard';
import { pictureUrl } from '../../utils/imageLoading';

import { copyFor } from '../../copy/copy';

import { DefaultRepImageURL } from '../../containers/DefaultStyles/Shared';

const MainTitle = styled.h3`
    font-size: 12px;
    line-height: 18px;
    font-weight: normal;
    color: #000;
    margin: -6px 0 12px 0;
`;

class EmailDetailsMultiRepStep2 extends React.Component {
    static propTypes = {
        actionCompletedTime: PropTypes.func.isRequired,
        activeAction: PropTypes.object.isRequired,
        actionIdentifier: PropTypes.string.isRequired,
        apiRequestData: PropTypes.object.isRequired,
        cacheFormData: PropTypes.func.isRequired,
        cards: PropTypes.array.isRequired,
        currentFormValues: PropTypes.object.isRequired,
        emailableReps: PropTypes.array.isRequired,
        emailMessage: PropTypes.string,
        emailSubject: PropTypes.string,
        emailSubmitError: PropTypes.string,
        emailTopic: PropTypes.string,
        formattedRepsWithDistrict: PropTypes.string,
        formValues: PropTypes.object,
        handleSkippingEndCard: PropTypes.func.isRequired,
        isBackTransition: PropTypes.bool,
        isEmailMessageChanged: PropTypes.bool.isRequired,
        isLocalRepLoading: PropTypes.bool,
        isMultiActionsCard: PropTypes.bool.isRequired,
        isRepDoubleCheckLoading: PropTypes.bool.isRequired,
        isSubmitting: PropTypes.bool.isRequired,
        localRepData: PropTypes.object,
        localRepFound: PropTypes.bool.isRequired,
        multiRepFormValues: PropTypes.object,
        nextAction: PropTypes.object,
        onBackFromStep2: PropTypes.func.isRequired,
        onEmailComplete: PropTypes.func.isRequired,
        onEmailMessageChange: PropTypes.func.isRequired,
        onGoToNextCard: PropTypes.func.isRequired,
        recipientMask: PropTypes.string,
        repImages: PropTypes.array,
        representativeSearch: PropTypes.object,
        response: PropTypes.string,
        setExitingCardProps: PropTypes.func.isRequired,
        setPrefixModalVisibility: PropTypes.func.isRequired,
        shouldPromptRepDoubleCheck: PropTypes.bool.isRequired,
        showDoubleCheckRepPopUp: PropTypes.bool.isRequired,
        skipEndCard: PropTypes.bool,
        toggleDoubleCheckRepPopup: PropTypes.func.isRequired,
        useLocalRepresentative: PropTypes.bool,
        articleUrl: PropTypes.string.isRequired,
        widgetRequestId: PropTypes.string.isRequired,
        widgetBounce: PropTypes.func.isRequired,
        bounceDismissed: PropTypes.bool.isRequired,
        answerId: PropTypes.number,
        recordVideoEmailData: PropTypes.object
    };

    sendEmail(formValues){
        this.props.onEmailComplete(
            this.props.apiRequestData,
            this.props.actionCompletedTime(),
            formValues,
            this.props.localRepData,
            this.props.isMultiActionsCard,
            this.props.activeAction,
            this.props.recipientMask,
            this.props.activeAction
                .representativeSearch,
            this.props.emailSubject,
            this.props.emailTopic,
            this.props.emailMessage,
            this.props.emailableReps,
            this.props.skipEndCard,
            this.props.isRecordVideoAction,
            this.props.answerId,
            this.props.recordVideoEmailData,
            this.props.partnerName,
            this.props.hiddenReps
        );
    }

    render() {
        return (
            <TransitionContainer
                zIndex={7}
                isSubmitting={this.props.isSubmitting}
                isBackTransition={this.props.isBackTransition}
            >
                <Container>
                    <Overlay />
                    <OverlayPublisher />
                    <OverlayPartner transitionType="right-to-left" />
                    <TransitionGroup>
                        {this.props.emailSubmitError && (
                            <CssTransition key="alert" in={this.props.emailSubmitError}>
                                <ToasterAlert content={this.props.emailSubmitError} />
                            </CssTransition>
                        )}
                    </TransitionGroup>
                    <Body>
                        <WidgetHeader />
                        <Content>
                            <ContentContainer>
                                <MainTitle>
                                    {copyFor('multiRepDetails', 'infoRequired', 'email')}
                                </MainTitle>
                                <DetailsFormMultiRepStep2
                                    onSubmit={() => {
                                        if (this.props.shouldPromptRepDoubleCheck) {
                                            this.props.toggleDoubleCheckRepPopup();
                                        } else {
                                            this.props.cacheFormData(
                                                this.props.multiRepFormValues
                                            );
                                            this.props.setExitingCardProps(
                                                this.props.activeAction.type,
                                                this.props,
                                                this.props.activeAction
                                            );
                                            if (this.props.skipEndCard) {
                                                this.props.handleSkippingEndCard(
                                                    this.props.nextAction,
                                                    this.props.cards,
                                                    this.props.onGoToNextCard
                                                );
                                            }
                                            this.sendEmail(this.props.multiRepFormValues)
                                        }
                                    }}
                                    response={this.props.response}
                                    onBackFromStep2={() => {
                                        if(this.props.isRecordVideoAction){
                                            this.props.onBackFromStep2(true);
                                        } else if (!this.props.bounceDismissed) {
                                            this.props.widgetBounce(
                                                true,
                                                this.props.widgetRequestId,
                                                this.props.articleUrl,
                                                this.props.currentFormValues,
                                                this.props.actionIdentifier
                                            );
                                        } else {
                                            this.props.setExitingCardProps(
                                                this.props.activeAction.type,
                                                this.props,
                                                this.props.activeAction
                                            );
                                            this.props.onBackFromStep2();
                                        }
                                    }}
                                    isSubmitting={this.props.isSubmitting}
                                    isEmailMessageChanged={
                                        this.props.isEmailMessageChanged
                                    }
                                    onEmailMessageChange={this.props.onEmailMessageChange}
                                    setPrefixModalVisibility={
                                        this.props.setPrefixModalVisibility
                                    }
                                />
                            </ContentContainer>
                        </Content>
                    </Body>
                    {this.props.localRepFound && this.props.useLocalRepresentative && (
                        <TransitionGroup>
                            {this.props.showDoubleCheckRepPopUp && (
                                <CssTransition
                                    key="alert"
                                    in={this.props.showDoubleCheckRepPopUp}
                                >
                                    <RepEmailRedirectPopup
                                        isSubmitting={this.props.isRepDoubleCheckLoading}
                                        formattedReps={
                                            this.props.formattedRepsWithDistrict
                                        }
                                        toggleDoubleCheckRepPopup={
                                            this.props.toggleDoubleCheckRepPopup
                                        }
                                        imgSources={this.props.repImages}
                                        isLocalRepLoading={this.props.isLocalRepLoading}
                                        onSubmit={() => {
                                            this.props.cacheFormData(
                                                this.props.formValues
                                            );
                                            this.props.setExitingCardProps(
                                                this.props.activeAction.type,
                                                this.props,
                                                this.props.activeAction
                                            );

                                            if (this.props.skipEndCard) {
                                                this.props.handleSkippingEndCard(
                                                    this.props.nextAction,
                                                    this.props.cards,
                                                    this.props.onGoToNextCard
                                                );
                                            }
                                            this.sendEmail(this.props.formValues)
                                        }}
                                    />
                                </CssTransition>
                            )}
                        </TransitionGroup>
                    )}
                </Container>
            </TransitionContainer>
        );
    }
}

export default (actionType, route) =>  connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            actionType,
            [route],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        const nextAction = getNextAction(
            state.widget.actions,
            state.widget.activeAction.identifier,
            buildConditionalActionsAnswerHistory(state),
            state.widget.cards
        );
        const reps = state.localRep.localRepData
            ? relevantRepresentatives(
                  state.widget.activeAction.representativeSearch,
                  state.localRep.localRepData.representative
              )
            : [];
        const country = ((state.localRep.localRepData || {}).address || {}).country;
        const formattedRepsWithDistrict = joinEnglish(
            reps.map(rep => `${rep.title} ${rep.fullName}${districtInfo(rep)}`)
        );
        const emailableReps = reps.filter(rep => rep.canBeEmailed).slice(0, 3);

        const repImages = !!state.widget.activeAction.representativeSearch
            ? emailableReps.map(rep => rep.photoUrl || DefaultRepImageURL(country))
            : [pictureUrl(state) || DefaultRepImageURL(country)];

        const isRecordVideoAction = state.widget.activeAction.type === 'recordvideo';
        const formValues = (state.form.emailDetailsFormMultiRepStep2 || {}).values || {};

        return {
            activeAction: state.widget.activeAction,
            actionCompletedTime: getActionCompletedTime(state, 'email'),
            actionIdentifier: state.widget.activeAction.identifier,
            apiRequestData: state.widget.apiRequestData,
            bounce: state.widget.bounce,
            cards: state.widget.cards,
            currentFormValues: (state.form['emailDetailsFormMultiRepStep2'] || {}).values,
            emailableReps,
            emailMessage: state.email.message,
            emailSubmitError: state.email.emailSubmitError
                ? state.email.emailSubmitError.message || state.email.emailSubmitError
                : state.email.emailSubmitError,
            emailTopic: isRecordVideoAction ? formValues.topic : (state.email.topic || ''),
            emailSubject: state.email.subject,
            formValues,
            formattedRepsWithDistrict,
            hiddenReps: state.localRep.hiddenRepresentatives,
            isBackTransition: state.email.backButtonClicked,
            isEmailMessageChanged: state.email.isEmailMessageChanged,
            isMultiActionsCard:
                state.widget.cards[state.widget.activeAction.order - 1].type ===
                CardTypes.multipleActions,
            isSubmitting: state.email.isSubmitting,
            localRepData: state.localRep.localRepData,
            isLocalRepLoading: state.localRep.isLocalRepLoading,
            isLocalRepPopupLoading: state.localRep.isLocalRepPopupLoading,
            isRecordVideoAction,
            isRepDoubleCheckLoading: state.localRep.isRepDoubleCheckLoading,
            nextAction,
            recipientMask: state.widget.activeAction.recipientMask,
            repImages,
            response: state.widget.activeAction.text,
            skipEndCard: state.widget.activeAction.skipEndCard && !!nextAction,
            localRepFound: state.localRep.localRepData.representative !== undefined,
            useLocalRepresentative: !!state.widget.activeAction.representativeSearch,
            shouldPromptRepDoubleCheck: state.localRep.shouldPromptRepDoubleCheck,
            showDoubleCheckRepPopUp: state.localRep.showDoubleCheckRepPopUp,
            address: state.form.google_autocomplete
                ? state.form.google_autocomplete.values.address
                : '',
            multiRepFormValues: {
                ...((state.form.emailDetailsFormMultiRepStep1 || {}).values || {}),
                ...((state.form.emailDetailsFormMultiRepStep2 || {}).values || {})
            },
            widgetRequestId: state.widget.widgetRequestId,
            articleUrl: state.widget.articleUrl,
            bounceDismissed: state.widget.bounceDismissed,
            answerId: state.recordVideo.answerId,
            recordVideoEmailData: {
                subject: state.widget.activeAction.emailSubject || copyFor('email','subject','recordvideo'),
                body: state.widget.activeAction.emailText || copyFor('email','body','recordvideo'),
                videoURL: state.recordVideo.videoURL
            },
            partnerName: state.widget.activeAction.partner && state.widget.activeAction.partner.name
        };
    },
    {
        cacheFormData,
        handleSkippingEndCard,
        hideFindRepPopup,
        loadLocalRep,
        onBackFromStep2,
        onEmailComplete,
        onEmailMessageChange,
        onGoToNextCard,
        setExitingCardProps,
        setPrefixModalVisibility,
        toggleDoubleCheckRepPopup,
        widgetBounce
    }
)(EmailDetailsMultiRepStep2);
